import { render, staticRenderFns } from "./AfIsLoading.vue?vue&type=template&id=5d3764c3&scoped=true"
import script from "./AfIsLoading.vue?vue&type=script&lang=ts"
export * from "./AfIsLoading.vue?vue&type=script&lang=ts"
import style0 from "./AfIsLoading.vue?vue&type=style&index=0&id=5d3764c3&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3764c3",
  null
  
)

export default component.exports